module.exports = __webpack_public_path__ + "img/el.08fa60ec.png";